"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraManager = void 0;
const THREE = __importStar(require("three"));
const gl_matrix_1 = require("gl-matrix");
const viewer_rendering_engine_camera_engine_1 = require("@shapediver/viewer.rendering-engine.camera-engine");
class CameraManager {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        // #region Properties (2)
        this._orthographicCameraThree = new THREE.OrthographicCamera(1, 1, 1, 1, 1, 1);
        this._perspectiveCameraThree = new THREE.PerspectiveCamera(1, 1, 1, 1);
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    updateCamera(time, aspect) {
        var _a;
        if (((_a = this._renderingEngine.cameraEngine.camera) === null || _a === void 0 ? void 0 : _a.type) === 'perspective')
            this._renderingEngine.cameraEngine.camera.aspect = aspect;
        return this._renderingEngine.cameraEngine.camera.update(time);
    }
    load(camera, dataChild) {
        let threeCamera = dataChild.children[0] instanceof THREE.Camera ? dataChild.children[0] : null;
        if (camera instanceof viewer_rendering_engine_camera_engine_1.PerspectiveCamera) {
            if (!threeCamera) {
                threeCamera = new THREE.PerspectiveCamera();
                dataChild.add(threeCamera);
            }
            const perspectiveCamera = camera;
            const threePerspectiveCamera = threeCamera;
            threePerspectiveCamera.up.set(0, 0, 1);
            if (perspectiveCamera.useNodeData) {
                threePerspectiveCamera.fov = perspectiveCamera.fov;
                threePerspectiveCamera.aspect = perspectiveCamera.aspect;
                threePerspectiveCamera.far = perspectiveCamera.far;
                threePerspectiveCamera.near = perspectiveCamera.near;
                threePerspectiveCamera.updateProjectionMatrix();
            }
        }
        else {
            if (!threeCamera) {
                threeCamera = new THREE.OrthographicCamera(0, 0, 0, 0);
                dataChild.add(threeCamera);
            }
            const orthographicCamera = camera;
            const threeOrthographicCamera = threeCamera;
            threeOrthographicCamera.up.set(orthographicCamera.up[0], orthographicCamera.up[1], orthographicCamera.up[2]);
            if (orthographicCamera.useNodeData) {
                threeOrthographicCamera.left = orthographicCamera.left;
                threeOrthographicCamera.bottom = orthographicCamera.bottom;
                threeOrthographicCamera.right = orthographicCamera.right;
                threeOrthographicCamera.top = orthographicCamera.top;
                threeOrthographicCamera.near = orthographicCamera.near;
                threeOrthographicCamera.far = orthographicCamera.far;
                threeOrthographicCamera.updateProjectionMatrix();
            }
        }
    }
    adjustCamera(aspect) {
        let cameraThree;
        const camera = this._renderingEngine.cameraEngine.camera;
        if (camera.useNodeData) {
            const sdCameraNode = camera.node.transformedNodes[this._renderingEngine.id];
            const sdCameraData = sdCameraNode.children[0];
            cameraThree = sdCameraData.children[0];
        }
        else {
            if (this._renderingEngine.cameraEngine.camera.type === viewer_rendering_engine_camera_engine_1.CAMERATYPE.ORTHOGRAPHIC) {
                const camera = this._renderingEngine.cameraEngine.camera;
                const distance = gl_matrix_1.vec3.distance(camera.position, camera.target) / 2;
                this._orthographicCameraThree.up.set(camera.up[0], camera.up[1], camera.up[2]);
                this._orthographicCameraThree.left = camera.left = -distance * aspect;
                this._orthographicCameraThree.bottom = camera.bottom = -distance;
                this._orthographicCameraThree.right = camera.right = distance * aspect;
                this._orthographicCameraThree.top = camera.top = distance;
                this._orthographicCameraThree.near = camera.near = 0.01;
                this._orthographicCameraThree.far = camera.far = 100 * distance;
                this._orthographicCameraThree.position.set(camera.position[0], camera.position[1], camera.position[2]);
                this._orthographicCameraThree.lookAt(camera.target[0], camera.target[1], camera.target[2]);
                this._orthographicCameraThree.updateProjectionMatrix();
                cameraThree = this._orthographicCameraThree;
            }
            else {
                const camera = this._renderingEngine.cameraEngine.camera;
                this._perspectiveCameraThree.up.set(0, 0, 1);
                const fov = this._renderingEngine.cameraEngine.camera.fov;
                const bs = this._renderingEngine.sceneTreeManager.boundingBox.boundingSphere;
                const radius = bs.radius > 0 ? bs.radius : 2;
                this._perspectiveCameraThree.fov = camera.fov = fov;
                this._perspectiveCameraThree.aspect = camera.aspect = aspect;
                this._perspectiveCameraThree.far = camera.far = (fov < 10 ? fov * 100.0 * 100 * radius : 100 * radius);
                this._perspectiveCameraThree.near = camera.near = (fov < 10 ? fov * 100.0 * 0.01 * radius : 0.01 * radius);
                this._perspectiveCameraThree.position.set(camera.position[0], camera.position[1], camera.position[2]);
                this._perspectiveCameraThree.lookAt(camera.target[0], camera.target[1], camera.target[2]);
                this._perspectiveCameraThree.updateProjectionMatrix();
                cameraThree = this._perspectiveCameraThree;
            }
        }
        return cameraThree;
    }
    init() {
        this._orthographicCameraThree.up.set(0, 1, 0);
    }
}
exports.CameraManager = CameraManager;
//# sourceMappingURL=CameraManager.js.map